export enum RaterApprovalStatus {
  None,
  Approver,
  NeedApproval,
  Approved,
  Declined,
  WaitingForApproval
}